export function AddOptionPlugin(options) {
  const tomSelect = this

  // Do not show "No Results" in the search list when no matching items for the search term - Matt, Scott, Fri Jan 2 2025
  tomSelect.settings.render.no_results = () => undefined

  let addOptionActive = false

  tomSelect.hook("after", "setup", () => {
    const addOption = document.createElement("div")
    addOption.setAttribute("class", "add-option")
    addOption.setAttribute("tabindex", "0")
    addOption.innerHTML = "Add&nbsp;"

    const optionText = document.createElement("strong")
    addOption.appendChild(optionText)

    tomSelect.dropdown.appendChild(addOption)

    addOption.addEventListener("click", (e) => {
      openModal()
    })

    addOption.addEventListener("mouseenter", () => {
      setAddOptionActive(true)
    })

    tomSelect.dropdown_content.addEventListener("mouseenter", () => {
      setAddOptionActive(false)
    })

    function setAddOptionActive(active) {
      addOptionActive = active
      if (addOptionActive) {
        tomSelect.setActiveOption(null)
        addOption.classList.add("active")
      } else {
        addOption.classList.remove("active")
      }
    }

    tomSelect.on("dropdown_open", () => {
      //## Reconsider when making changes to how blank option plugin works - Matt, Stephen, Wed Jan 7 2026
      if (Object.keys(tomSelect.options).length === 0) {
        setAddOptionActive(true)
      }
    })

    // Override onKeyDown to allow keyboard navigation to and from the add-option - Matt, Scott, Fri Jan 2 2025
    const originalOnKeyDown = tomSelect.onKeyDown.bind(tomSelect)
    tomSelect.hook("instead", "onKeyDown", (e) => {
      if (!tomSelect.isOpen) {
        return originalOnKeyDown(e)
      }

      if (e.key === "ArrowDown") {
        const activeOption = tomSelect.activeOption

        if (activeOption) {
          const nextOption = tomSelect.getAdjacent(activeOption, 1)

          if (!nextOption) {
            e.preventDefault()

            setAddOptionActive(true)

            return
          }
        }
      }

      if (e.key === "ArrowUp") {
        if (addOptionActive) {
          const lastOption = getLastOption()

          if (lastOption) {
            e.preventDefault()

            setAddOptionActive(false)
            tomSelect.setActiveOption(lastOption)

            return
          }
        }
      }

      if (e.key === "Enter" && addOptionActive) {
        e.preventDefault()

        openModal()

        return
      }

      return originalOnKeyDown(e)
    })

    tomSelect.on("dropdown_close", () => {
      setAddOptionActive(false)
    })

    tomSelect.on("type", (searchTerm) => {
      if (searchTerm.length) {
        optionText.textContent = searchTerm
        addOption.setAttribute("title", searchTerm)
      } else {
        clearAddOptionText()
      }

      if (tomSelect.currentResults.total === 0) {
        setAddOptionActive(true)
      } else if (addOptionActive) {
        setAddOptionActive(false)
      }
    })

    // When the dropdown is closed, the add option text should be reset - Matt, Scott, Fri Jan 2 2025
    tomSelect.on("blur", () => {
      clearAddOptionText()
    })

    function clearAddOptionText() {
      optionText.textContent = ""
      addOption.removeAttribute("title")
    }

    tomSelect.control_input.addEventListener("keydown", (e) => {
      if (e.key === "Tab" && !e.shiftKey) {
        e.preventDefault()
        e.stopPropagation()

        if (addOptionActive) {
          tomSelect.close()
        } else {
          setAddOptionActive(true)
        }
      }

      if (e.key === "Enter") {
        e.preventDefault()

        if (tomSelect.currentResults.total === 0) {
          openModal()
        }
      }
    }, true)

    // Intercept onBlur to prevent closing when focus moves to add option - Matt, Stephen, Wed Dec 31 2025
    const originalOnBlur = tomSelect.onBlur.bind(tomSelect)
    tomSelect.hook("instead", "onBlur", (e) => {
      if (e && e.relatedTarget === addOption) {
        return
      }

      return originalOnBlur(e)
    })
  })

  function getLastOption() {
    const options = tomSelect.dropdown_content.querySelectorAll("[data-selectable]")

    if (options.length === 0) {
      return null
    }

    return options[options.length - 1]
  }

  async function openModal() {
    const inputValue = tomSelect.control_input.value

    tomSelect.close()

    return renderModal(inputValue)
  }

  async function renderModal(input) {
    const url = new URL(options.url, window.location.origin)
    url.searchParams.set("input", input)

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
      }
    })

    const html = await response.text()
    Turbo.renderStreamMessage(html)
  }
}
